export function buildUnlockRequestMailto({ corporateName, moduleName, benefits, requester }) {
  const to = 'business@omnihotelier.com'
  
  let finalCorporateName = corporateName;
  if (!finalCorporateName || finalCorporateName === 'Corporate Account' || finalCorporateName === 'dummy') {
    try {
      const selectedProfileStr = window.localStorage?.getItem('selected_business_profile');
      if (selectedProfileStr) {
        const profile = JSON.parse(selectedProfileStr);
        if (profile.corporate_name) {
          finalCorporateName = profile.corporate_name;
        }
      }
    } catch (e) {
      // ignore
    }
  }
  
  const corpNameClean = (finalCorporateName || 'Corporate Account').replace(/[\r\n]+/g, ' ')
  const moduleNameClean = (moduleName || 'Module').replace(/[\r\n]+/g, ' ')
  
  const subject = `Feature Activation Request - ${moduleNameClean} | ${corpNameClean}`
  
  const benefitLines = (benefits || []).map(b => `- ${b.title || b}`).join('\n')
  
  const firstName = requester?.first_name || '';
  const lastName = requester?.last_name || '';
  let reqName = `${firstName} ${lastName}`.trim();
  if (!reqName) {
    reqName = requester?.name || requester?.username || 'Admin';
  }
  reqName = reqName.replace(/[\r\n]+/g, ' ')

  const reqLevel = (requester?.level || 'Corporate Admin').replace(/[\r\n]+/g, ' ')
  const reqEmail = (requester?.email || '-').replace(/[\r\n]+/g, ' ')
  const todayStr = new Date().toLocaleDateString('en-GB', { day: '2-digit', month: 'long', year: 'numeric' })

  const body = 
`Dear Omni Hotelier Business Team,

We would like to request the activation of the following premium feature for our corporate membership account.

Corporate Information

- Corporate Name : ${corpNameClean}
- Requested Feature : ${moduleNameClean}

Requested By

- Name : ${reqName}
- Role : ${reqLevel}
- Email : ${reqEmail}
- Request Date : ${todayStr}

Business Objectives

We are interested in utilizing this feature to:

${benefitLines}

Further Information Requested

Please provide us with the following details:

- Pricing and subscription requirements.
- Feature activation process.
- Onboarding or implementation guidelines.
- Any applicable terms and conditions.

We look forward to your response and appreciate your assistance.

Best regards,
${reqName}
${corpNameClean}`

  return `mailto:${to}?subject=${encodeURIComponent(subject)}&body=${encodeURIComponent(body)}`
}

export const buildMailto = (corporate, featureName) => {
  const corporateName = corporate?.name || corporate?.corporate_name || 'Corporate Account'
  return buildUnlockRequestMailto({
    corporateName,
    moduleName: featureName,
    benefits: [],
    requester: null
  })
}
